function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import React from 'react';
import { LocaleProvider } from 'oskari-ui/util';
import ReactDOM from 'react-dom';
import { ToolPanelHandler } from '../handler/ToolPanelHandler';
import { PublisherToolsList } from './form/PublisherToolsList';
import { ThemeProvider } from 'oskari-ui/util';

/**
 * @class Oskari.mapframework.bundle.publisher.view.PanelAdditionalTools
 *
 */
Oskari.clazz.define('Oskari.mapframework.bundle.publisher2.view.PanelReactTools',
/**
 * @method create called automatically on construction
 * @static
 */
function (tools, groupId) {
  this.groupId = groupId;
  this.tools = tools ? _toConsumableArray(tools) : [];
  this.tools = _toConsumableArray(this.tools).sort(function (a, b) {
    return a.index - b.index;
  });
  this.panel = null;
  this.handler = null;
}, {
  /**
   * @method init
   * Creates the Oskari.userinterface.component.AccordionPanel where the UI is rendered
   */
  init: function init(data) {
    var _this = this;
    this.handler = new ToolPanelHandler(this.tools, function () {
      return _this._updateUI();
    });
    return this.handler.init(data);
  },
  getName: function getName() {
    return "Oskari.mapframework.bundle.publisher2.view.PanelReactTools.".concat(this.groupId);
  },
  /**
   * Returns the UI panel and populates it with the data that we want to show the user.
   *
   * @method getPanel
   * @return {Oskari.userinterface.component.AccordionPanel}
   */
  getPanel: function getPanel() {
    if (!this.panel) {
      this.panel = Oskari.clazz.create('Oskari.userinterface.component.AccordionPanel');
      this.panel.setTitle(Oskari.getMsg('Publisher2', "BasicView.".concat(this.groupId, ".label")));
      this._updateUI();
    }
    return this.panel;
  },
  /**
   * @method getValues
   * @return {Object}
   */
  getValues: function getValues() {
    // just return empty -> tools and their plugins' configs get returned by the layout panel, which has all the tools
    return null;
  },
  /**
   * Returns any errors found in validation (currently doesn't check anything) or an empty
   * array if valid. Error object format is defined in Oskari.userinterface.component.FormInput
   * validate() function.
   *
   * @method validate
   * @return {Object[]}
   */
  validate: function validate() {
    return [];
  },
  /**
   * Populates the map layers panel in publisher
   *
   * @method _updateUI
   * @private
   */
  _updateUI: function _updateUI() {
    if (!this.panel) {
      return;
    }
    var contentPanel = this.panel.getContainer();
    ReactDOM.render(/*#__PURE__*/React.createElement(ThemeProvider, null, /*#__PURE__*/React.createElement(LocaleProvider, {
      value: {
        bundleKey: 'Publisher2'
      }
    }, /*#__PURE__*/React.createElement(PublisherToolsList, {
      state: this.handler.getState(),
      controller: this.handler.getController()
    }))), contentPanel[0]);
  },
  /**
  * Stop panel.
  * @method stop
  * @public
  **/
  stop: function stop() {
    this.handler.stop();
  }
});